import { ACTION_STATUSES } from "utils/constants";

/**
 * Only the action that started a hop may clear its status. Run updates land
 * while the hop is still in flight (the optimistic preview first, then the
 * real run), and clearing there re-enables the buttons on a screen whose
 * clicks nothing would handle yet: the click is swallowed and the user has to
 * click a second time.
 */
export const actionStatusRelease =
  ({ setActionStatus, isActionInFlight }) =>
  (next) => {
    if (isActionInFlight()) return;
    setActionStatus(next || { status: ACTION_STATUSES.IDLE });
  };

/**
 * Keep the departing screen mounted for the whole hop. Switching to the
 * optimistic next/back version is what painted a spinner on its Continuer.
 */
export const resolveHeldHopScreen = ({
  hopBusy,
  hopHold,
  publishedVersion,
  processingVersion,
  currentFormDefinition,
}) => {
  if (hopBusy && hopHold && hopHold.version) {
    return {
      version: hopHold.version,
      formDefinition: hopHold.formDefinition || currentFormDefinition,
    };
  }
  return {
    version: publishedVersion || processingVersion || null,
    formDefinition: currentFormDefinition,
  };
};

export const applyCanvasRunUpdate = async ({
  nextRun,
  setRun,
  setActionStatus,
  refetchStatusData,
  refreshProject,
  refreshFirst = false,
}) => {
  if (!nextRun) return false;
  if (refreshFirst && refreshProject) await refreshProject();
  setRun(nextRun);
  setActionStatus({ status: ACTION_STATUSES.IDLE });
  if (refetchStatusData) refetchStatusData();
  if (!refreshFirst && refreshProject) refreshProject();
  return true;
};
